// ── Márka szerviz-hubok tartalma ────────────────────────────────────────────
//
// Három oldal, nem öt. Az iPhone és a Samsung saját hubot kap (ezekre van
// valódi keresési volumen és mély aloldal is), a Xiaomi/Honor/Huawei pedig
// EGY közös Android-oldalon, márkánként külön szekcióval. Indok: Orosháza
// ~27 ezres – három külön, majdnem azonos oldal vékony tartalom lenne.
//
// SZABÁLY: csak olyan szolgáltatás és ár szerepelhet, amit tényleg végzünk.
// Ahol nincs tételes árlistánk (Samsung, Xiaomi, Honor, Huawei), ott a szöveg
// kimondja, hogy az ár a bevizsgálás után derül ki. Számot nem találunk ki.

export const MARKA_SZERVIZ = [
  {
    slug: 'iphone-szerviz-oroshaza',
    marka: 'iPhone',
    cim: 'iPhone szerviz Orosházán – kijelző, akku, hátlap | NorbiPhone',
    leiras: 'iPhone szerviz Orosházán: kijelzőcsere, akkumulátorcsere, hátlapcsere. Tételes árlista, ingyenes bevizsgálás, 6 hónap garancia, gyakran 1 óra alatt kész.',
    h1: 'iPhone szerviz Orosházán',
    bevezeto: 'Kijelzőcsere, akkumulátorcsere, hátlapcsere – iPhone 11-től a legújabb modellekig. A bevizsgálás ingyenes, és a javítás előtt pontos árat mondunk.',
    // Csak olyan tétel, amire VAN árlistánk vagy saját oldalunk.
    szolgaltatasok: [
      { nev: 'Kijelzőcsere', leiras: 'Eredeti Apple és OEM-minőségű utángyártott kijelzővel is. A True Tone és a szoftveres kalibrálás megmarad.', url: '/iphone-kijelzocsere-oroshaza/' },
      { nev: 'Akkumulátorcsere', leiras: 'Tételes árlista modellenként, 20 000 Ft-tól. Általában 1 óra alatt kész.', url: '/iphone-akkumulatorcsere-oroshaza/' },
      { nev: 'Hátlapcsere', leiras: 'Repedt vagy törött üveg hátlap cseréje, a készülék bontásával.', url: '/iphone-hatlapcsere/' },
    ],
    arlista: { van: true, szoveg: 'Az iPhone kijelző- és akkumulátorcsere árait tételesen, modellenként közöljük.', url: '/szerviz/#arlista' },
    gyik: [
      { q: 'Elvesznek az adataim a javítás során?', a: 'Nem. A kijelző-, akku- és hátlapcsere nem érinti az alaplapot és a memóriát. Biztonsági mentést azért minden javítás előtt ajánlunk.' },
      { q: 'Eredeti vagy utángyártott alkatrészt kapok?', a: 'Te döntöd el. Mindkettőt kínáljuk, az árlistában külön oszlopban látod a két árat. Nem a legolcsóbb, hamar hibásodó verzióval dolgozunk.' },
    ],
    keszletUrl: '/hasznalt-iphone-oroshaza/',
    keszletCim: 'Használt iPhone készletünk',
  },
  {
    slug: 'samsung-szerviz-oroshaza',
    marka: 'Samsung',
    cim: 'Samsung szerviz Orosházán – kijelzőcsere, akkucsere | NorbiPhone',
    leiras: 'Samsung szerviz Orosházán: Galaxy kijelzőcsere és akkumulátorcsere, ingyenes bevizsgálás, 6 hónap garancia. Az árat a bevizsgálás után pontosan megmondjuk.',
    h1: 'Samsung szerviz Orosházán',
    bevezeto: 'Galaxy S és A szériás készülékek javítása – kijelzőcsere, akkumulátorcsere, töltési hibák. A bevizsgálás ingyenes, és csak a jóváhagyásod után kezdünk hozzá.',
    szolgaltatasok: [
      { nev: 'Kijelzőcsere', leiras: 'Galaxy kijelzőcsere, saját oldalon részletezve.', url: '/samsung-kijelzocsere-oroshaza/' },
      { nev: 'Akkumulátorcsere', leiras: 'Samsung és Xiaomi akkumulátorcsere – modellkereső és árinformáció.', url: '/samsung-xiaomi-akkumulatorcsere/' },
      { nev: 'Töltési és egyéb hibák', leiras: 'Nem tölt, nem kapcsol be, vizes készülék – megnézzük, és megmondjuk, mi a baj.', url: '/szerviz/' },
    ],
    arlista: { van: false, szoveg: 'Samsung modellekre nincs kinyomtatott, tételes árlistánk: az alkatrész ára típusonként és beszerzésenként változik. A bevizsgálás ingyenes, és utána pontos, fix árat mondunk – csak a jóváhagyásod után kezdünk hozzá.' },
    gyik: [
      { q: 'Mennyibe kerül a Samsung kijelzőcsere?', a: 'Modelltől függ, és attól, hogy eredeti vagy utángyártott kijelzőt választasz. Hozd be, a bevizsgálás ingyenes – utána pontos árat mondunk, és csak akkor kezdünk hozzá, ha elfogadod.' },
      { q: 'Elveszik a Samsung-fiókom vagy az adataim?', a: 'Nem. A kijelző- és akkucsere nem érinti a tárhelyet. Biztonsági mentést azért minden javítás előtt ajánlunk.' },
    ],
    keszletUrl: '/hasznalt-samsung-telefon-oroshaza/',
    keszletCim: 'Használt Samsung készletünk',
  },
  {
    slug: 'android-szerviz-oroshaza',
    marka: 'Android',
    cim: 'Xiaomi, Honor és Huawei szerviz Orosházán | NorbiPhone',
    leiras: 'Android telefon szerviz Orosházán: Xiaomi, Redmi, POCO, Honor és Huawei kijelzőcsere és akkumulátorcsere. Ingyenes bevizsgálás, pontos ár a javítás előtt.',
    h1: 'Android szerviz Orosházán – Xiaomi, Honor, Huawei',
    bevezeto: 'Nem csak iPhone-t és Samsungot javítunk. Xiaomi, Redmi, POCO, Honor és Huawei készülékeket is elvállalunk. A bevizsgálás mindig ingyenes, és ha valamit nem tudunk megcsinálni, azt előre megmondjuk.',
    // Márkánként KÜLÖN szekció – ez az, ami miatt ez egy oldal lehet, nem három.
    markak: [
      {
        nev: 'Xiaomi',
        h: 'Xiaomi szerviz Orosházán',
        szoveg: 'Xiaomi, Redmi és POCO készülékek kijelző- és akkumulátorcseréje. A három név ugyanazt a gyártót takarja, az alkatrészek nagyrészt közösek – ezért a legtöbb modellre gyorsan tudunk megoldást adni.',
        link: { cim: 'Samsung & Xiaomi akkumulátorcsere', url: '/samsung-xiaomi-akkumulatorcsere/' },
      },
      {
        nev: 'Honor',
        h: 'Honor szerviz Orosházán',
        szoveg: 'Honor kijelző- és akkumulátorcsere. A Honor 2020 óta önálló cég, nem a Huawei része – az alkatrészellátása is külön fut. Tételes árlistánk erre a márkára nincs: a bevizsgálás után mondunk pontos árat, és megmondjuk, mennyi idő beszerezni az alkatrészt.',
        link: { cim: 'Használt Honor készülékek', url: '/hasznalt-honor-telefon-oroshaza/' },
      },
      {
        nev: 'Huawei',
        h: 'Huawei szerviz Orosházán',
        szoveg: 'Huawei kijelző- és akkumulátorcsere. Tételes árlistánk erre a márkára sincs, ezért itt is a bevizsgálás után mondunk fix árat. Ha az alkatrészt nem tudjuk beszerezni, azt előre közöljük – nem kezdünk bele olyan javításba, amit nem tudunk befejezni.',
        link: { cim: 'Használt Huawei készülékek', url: '/hasznalt-huawei-telefon-oroshaza/' },
      },
    ],
    arlista: { van: false, szoveg: 'Ezekre a márkákra nincs kinyomtatott, tételes árlistánk – az alkatrészár típusonként és beszerzésenként változik. Ezért így dolgozunk: ingyenes bevizsgálás, utána fix ár, és csak a jóváhagyásod után kezdünk hozzá.' },
    gyik: [
      { q: 'Tényleg minden Android márkát javítotok?', a: 'A leggyakoribbakat igen. Ha olyan készüléket hozol, amihez nem tudunk alkatrészt szerezni, azt a bevizsgálás után megmondjuk – a bevizsgálásért nem kérünk pénzt, és nem beszélünk rá olyan javításra, aminek nincs értelme.' },
      { q: 'Miért nincs árlista Honorra és Huaweire?', a: 'Mert nem lenne őszinte. Ezeknél a márkáknál az alkatrész ára és elérhetősége modellenként és beszerzésenként is eltér. Inkább nem írunk ki számot, mint hogy olyat ígérjünk, amit nem tudunk tartani.' },
    ],
    keszletUrl: '/telefonok/',
    keszletCim: 'Használt készletünk',
  },
];

export const markaSzervizSlugbol = (slug) =>
  MARKA_SZERVIZ.find((m) => m.slug === slug) || null;

export const MARKA_SZERVIZ_UTVONALAK = MARKA_SZERVIZ.map((m) => `/${m.slug}`);
